export default __webpack_public_path__ + "static/intro-9abe41021add49b4b50caf6c52eb5da1.png";